import { render, staticRenderFns } from "./Ubicaciones.vue?vue&type=template&id=3f0b9751&"
import script from "./Ubicaciones.vue?vue&type=script&lang=js&"
export * from "./Ubicaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports